module.exports = __webpack_public_path__ + "static/img/aboutImg2.59d09d6d.png";